import { Card, Select } from "@shopify/polaris";
import React, {  useState,useMemo } from "react";
import { useEffect } from "react";
import { useSelector} from "react-redux";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { getOrderStatisticsCsv, reqGetOrderStatistics } from "../../../../api";
import intl from "../../../../i18n/intl";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import utils from '../../../../utils/utils'
import Tooltips from "./Tooltips";
export default function FulfilledOrders(props) {
  const language = useSelector(state => state.languageReducer.language);
  let defalutData = useMemo(()=>{
    let data = {
      orderStaticsTable: [
        {
          date: "10/1",
          Sales: 0,
          Costs: 0,
          Profits: 0,
          orders: 0,
        },
        {
          date: "10/2",
          Sales: 0,
          Costs: 0,
          Profits: 0,
          orders: 0,
        },
        {
          date: "10/3",
          Sales: 0,
          Costs: 0,
          Profits: 0,
          orders: 0,
        },
        {
          date: "10/4",
          Sales: 0,
          Costs: 0,
          Profits: 0,
          orders: 0,
        },
        {
          date: "10/5",
          Sales: 0,
          Costs: 0,
          Profits: 0,
          orders: 0,
        },
        {
          date: "10/6",
          Sales: 0,
          Costs: 0,
          Profits: 0,
          orders: 0,
        },
        {
          date: "10/7",
          Sales: 0,
          Costs: 0,
          Profits: 0,
          orders: 0,
        },
      ],
      orderStatics: {
        costs: 0,
        orders: 0,
        profits: 0,
        sales: 0,
      },
    }
    if (language) {
      data = {
        orderStaticsTable: [
          {
            date: "10/1",
            Sales: 0,
            Costs: 0,
            Profits: 0,
            orders: 0,
          },
          {
            date: "10/2",
            Sales: 0,
            Costs: 0,
            Profits: 0,
            orders: 0,
          },
          {
            date: "10/3",
            Sales: 0,
            Costs: 0,
            Profits: 0,
            orders: 0,
          },
          {
            date: "10/4",
            Sales: 0,
            Costs: 0,
            Profits: 0,
            orders: 0,
          },
          {
            date: "10/5",
            Sales: 0,
            Costs: 0,
            Profits: 0,
            orders: 0,
          },
          {
            date: "10/6",
            Sales: 0,
            Costs: 0,
            Profits: 0,
            orders: 0,
          },
          {
            date: "10/7",
            Sales: 0,
            Costs: 0,
            Profits: 0,
            orders: 0,
          },
        ],
        orderStatics: {
          costs: 0,
          orders: 0,
          profits: 0,
          sales: 0,
        },
      }
    }
    return data;
  },[language]);
  const [orderData, setOrderData] = useState(defalutData);
  const [selected, setSelected] = useState('1');
  const options = [
    { label: intl.get("Today"), value: '1' },
    { label: intl.get("Last 7 days"), value: '2' },
    { label: intl.get("Last 30 days"), value: '3' },
    { label: intl.get("Last 90 days"), value:'4' },
    { label: intl.get("Last year"), value: '5' },
  ];

  const getOrderData = async (value) => {
    let params = {
      type: value,
    };
    let res = await reqGetOrderStatistics(params);
    if (res.code === "200") {
      setOrderData((prevValue) => ({
        ...prevValue,
        orderStaticsTable: res.data.order_statistics_table,
        orderStatics: res.data.order_statistics,
      }));
    }
  };
  const getDefalutData = (data)=>{
    const svg = document.querySelector('.recharts-surface')
      if (svg) {
        svg.setAttribute('viewBox',`0 0 ${svg.getAttribute('width')} ${Number(svg.getAttribute('height'))+15}`)
      }
}
  useEffect(() => {
    let isMount = false;
    if (!isMount) {
      getDefalutData()
    }
    return () => {
      isMount = true;
    };
  }, [orderData]);
  useEffect(() => {
    let isMount = false;
    if (!isMount) {
      getOrderData('1');
    }
    return () => {
      isMount = true;
    };
  }, []);
  const handleSelectChange = (val)=>{
    setSelected(val)
    getOrderData(val)
  };
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length && payload[0].dataKey === 'Sales') {
      // console.log(active && payload && payload.length,payload);
      return (
        <div className="product-tooltip product-tooltips">
          <span>{payload[0].payload.date}</span>
          <p className="product_label">
            <span className={"product_tip_day"} style={{display:'flex',alignItems:'center'}}>
              {intl.get("Orders")}: <span> {payload[0].payload.orders ? payload[0].payload.orders : 0}</span> 
            </span>
            <span style={{display:'flex',alignItems:'center'}}>
              {intl.get("Sales")}: <span className={payload[0].payload.Sales <0 ? "product_tip_num product_tip_num_less" : 'product_tip_num'}> $ {payload[1].payload.Sales ? parseFloat((payload[1].payload.Sales).toFixed(2)) : 0}</span>
            </span>
            <span style={{display:'flex',alignItems:'center'}}>
              {intl.get("Costs")}: <span className={payload[0].payload.Costs <0 ? "product_tip_num product_tip_num_less" : 'product_tip_num'}> $ {payload[1].payload.Costs ? parseFloat((payload[1].payload.Costs).toFixed(2)) : 0}</span>
            </span>
            <span style={{display:'flex',alignItems:'center'}}>
              {intl.get("Profits")}: <span className={payload[0].payload.profits <0 ? "product_tip_num product_tip_num_less" : 'product_tip_num product_tip_nums'}> $ {payload[1].payload.profits ? parseFloat((payload[1].payload.profits).toFixed(2)) : 0}</span>
            </span>
          </p>
        </div>
      );
    }
    if (active && payload && payload.length && payload[1].dataKey === 'Costs') {
      return (
        <div className="product-tooltip product-tooltips">
          <span>{payload[1].payload.date}</span>
          <p className="product_label">
            <span className={"product_tip_day"} style={{display:'flex',alignItems:'center'}}>
              {intl.get("Orders")}: <span> {payload[1].payload.orders ? payload[1].payload.orders : 0}</span> 
            </span>
            <span style={{display:'flex',alignItems:'center'}}>
              {intl.get("Sales")}: <span className={payload[1].payload.Sales < 0 ? "product_tip_num product_tip_num_less" : 'product_tip_num'}> $ {payload[1].payload.Sales ? parseFloat((payload[1].payload.Sales).toFixed(2)) : 0}</span>
            </span>
            <span style={{display:'flex',alignItems:'center'}}>
              {intl.get("Costs")}: <span className={payload[1].payload.Costs < 0 ? "product_tip_num product_tip_num_less" : 'product_tip_num'}> $ {payload[1].payload.Costs ? parseFloat((payload[1].payload.Costs).toFixed(2)) : 0}</span>
            </span>
            <span style={{display:'flex',alignItems:'center'}}>
              {intl.get("Profits")}: <span className={payload[1].payload.profits < 0 ? "product_tip_num product_tip_num_less" : 'product_tip_num product_tip_nums'}> $ {payload[1].payload.profits ? parseFloat((payload[1].payload.profits).toFixed(2)) : 0}</span>
            </span>
          </p>
        </div>
      );
    }

    return null;
  };
  // csv 导出
  const handleExport = async ()=>{
    let params = {
      type: selected,
    };
    let res = await getOrderStatisticsCsv(params)
    if (res.code === '200') {
      var csv = convertToCSV(res.data);
      downloadCSV(csv);
    }
  }
  const convertToCSV = (data) => {
    var csv = '';
    for (var i = 0; i < data.length; i++) {
      var row = data[i];
      for (var j = 0; j < row.length; j++) {
        var val = row[j] === null ? '' : row[j].toString();
        if (val.indexOf(',') !== -1 || val.indexOf('"') !== -1 || val.indexOf('\n') !== -1) {
          val = '"' + val.replace(/"/g, '""') + '"';
        }
        if (j > 0) {
          csv += ',';
        }
        csv += val;
      }
      csv += '\n';
    }
    return csv;
  }

  const downloadCSV = (csv) => {
    var link = document.createElement('a');
    link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    link.download = 'data.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  
  const router = useHistory();
  return (
    <div className="fulfilled_orders_content" style={{marginBottom:'2.4rem'}}>
      <div className="fulfilled_orders_content_top">
        <div className="fulfilled_orders_content_top_title">{intl.get("Fulfilled Orders")}</div>
        <div className="fulfilled_orders_content_top_tips">
        <Tooltips text={intl.get('Displayed are Shopify orders fulfilled through Dropshipman, excluding manual, stock, and packaging orders')}/>
          </div>
        <div className="fulfilled_orders_content_select">
          <Select
            options={options}
            onChange={handleSelectChange}
            value={selected}
          />
        </div>
      </div>
      <Card>
        
      <div className="fulfilled_orders_content_lines">
        <div className="fulfilled_orders_content_line_item">
          <div className="fulfilled_orders_content_line_title" style={{paddingLeft:"24px"}}>
            <span style={{fontWeight:600,marginBottom:"16px",fontSize:'18px',}}>{intl.get("Orders")}</span>
            <span>{orderData.orderStatics?.orders}</span>
          </div>
          <div className="fulfilled_orders_content_line_title">
            <span style={{fontWeight:600,marginBottom:"16px",fontSize:'18px'}}>{intl.get("Sales")}</span>
            <span>$ {orderData.orderStatics?.sales.toFixed(2)}</span>
          </div>
          <div className="fulfilled_orders_content_line_title">
            <span style={{fontWeight:600,marginBottom:"16px",fontSize:'18px'}}>{intl.get("Costs")}</span>
            <span>$ {orderData.orderStatics?.costs.toFixed(2)}</span>
          </div>
          <div className="fulfilled_orders_content_line_title">
            <span style={{fontWeight:600,marginBottom:"16px",fontSize:'18px'}}>{intl.get("Profits")}</span>
            <span style={{color:orderData.orderStatics?.profits >= 0 ? "#303030" : "#f00"}}>$ {orderData.orderStatics?.profits.toFixed(2)}</span>
          </div>
          <div className="fulfilled_orders_content_line_title">
            <span style={{fontWeight:600,marginBottom:"16px",fontSize:'18px'}}>{intl.get("Unfulfilled")}</span>
           {props?.unfulfilledCount > 0 ? <span className="fulfilled_orders_content_line_title_unful fulfilled_orders_content_line_title_unfuls" onClick={()=>{
            utils.routeListen('/admin/order_list')
            utils.routeJump1(router,'/admin/order_list')
            }}>{props?.unfulfilledCount} <img src="/novice/unful_right.png" alt="dropshipman" /></span>
           :<span className="fulfilled_orders_content_line_title_unful">0</span>}
          </div>
          
        </div>
        <div className="fulfilled_orders_content_line" style={{height:'340px'}}>
        <ResponsiveContainer width='100%' height="100%">
          <LineChart
            data={orderData.orderStaticsTable}
            margin={{
              top: 5,
              right: 30,
              left: 0,
              bottom:-16,
            }}
          >
            <CartesianGrid strokeDasharray="2 2" />
            <XAxis dataKey="date"/>
            <YAxis />
            <Tooltip content={CustomTooltip} />
            <Legend />
            <Line type="monotone" dataKey={intl.get("Sales")} stroke="#00C3B4" />
            <Line type="monotone" dataKey={intl.get("Costs")} stroke="#bfbfbf" />
          </LineChart>
          </ResponsiveContainer>
        </div>
        <div className="fulfilled_orders_content_line_export">
          <span className="fulfilled_orders_content_line_export_span" onClick={()=>handleExport()}> <img src="/novice/download_export.png" alt="/dropshipman" /> {intl.get("Export")}</span>
          </div>
      </div>
      
      </Card>
    </div>
  );
}
